// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ess-historical-empty-state-icon {
    --cat-icon-fill: #6b7280;
    --cat-icon-height: 40px;
    --cat-icon-width: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Projects/EssHistoricalEmptyState.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B","sourcesContent":[".ess-historical-empty-state-icon {\n    --cat-icon-fill: #6b7280;\n    --cat-icon-height: 40px;\n    --cat-icon-width: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
